import React from 'react';
import AlgoliaStyleAttributesEditor from 'features/InternalTools/AlgoliaStyles/AlgoliaStyleAttributesEditor';
import {QueryClientProvider} from 'react-query';
import queryClient from 'src/shared/queryClient';
import {PigmentThemeProvider} from '@customink/pigment-react';

export default function EditStyleAlgoliaAttributesPage({
  backUrl,
  categoryImages,
  endpointUrl,
  imageConfig,
  initialUseLabImage,
  primaryCategoryId,
  styleCardImageUrl,
  styleId,
  colors
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <PigmentThemeProvider>
        <AlgoliaStyleAttributesEditor
          backUrl={backUrl}
          categoryImages={categoryImages}
          endpointUrl={endpointUrl}
          imageConfig={imageConfig}
          initialUseLabImage={initialUseLabImage}
          primaryCategoryId={primaryCategoryId}
          styleCardImageUrl={styleCardImageUrl}
          styleId={styleId}
          colors={colors}
        />
      </PigmentThemeProvider>
    </QueryClientProvider>
  );
}
